module.exports = __webpack_public_path__ + "static/media/loginBackground.33a5361c.jpg";